import { render, staticRenderFns } from "./MatrixAddToBasket.vue?vue&type=template&id=54d240ea&"
import script from "./MatrixAddToBasket.vue?vue&type=script&lang=js&"
export * from "./MatrixAddToBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\matrix_varianten\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d240ea')) {
      api.createRecord('54d240ea', component.options)
    } else {
      api.reload('54d240ea', component.options)
    }
    module.hot.accept("./MatrixAddToBasket.vue?vue&type=template&id=54d240ea&", function () {
      api.rerender('54d240ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/basket/MatrixAddToBasket.vue"
export default component.exports